function url() {
  let url = "http://localhost:8081";
  if (process.env.NODE_ENV === "production") {
    url = "https://mtmr.azurewebsites.net";
  }
  return url;
}

export const URL_API = url();
